import { render, staticRenderFns } from "./PhotosModal.vue?vue&type=template&id=6f756a6e&scoped=true&"
import script from "./PhotosModal.vue?vue&type=script&lang=js&"
export * from "./PhotosModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotosModal.vue?vue&type=style&index=0&id=6f756a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f756a6e",
  null
  
)

export default component.exports